import { fcoM } from '@/common/utilities/fcoI18n';
import { StoreError, WorksheetError } from '../constants/ordering';
import { QuoteItemTypes } from '../constants/quote';

export const isWorksheetLocked = (errorId) => errorId === WorksheetError.WORKSHEET_LOCKED;

export const isStoreDown = (errorId) => errorId === StoreError.STORE_DOWN;

export const orderWasSuccessful = (orderResponse) => {
    const { orderConfirmationNumber, orderSubmittedDatetime } = orderResponse;

    return orderConfirmationNumber && orderSubmittedDatetime;
};

export const itemHasCost = (item) => Boolean(item.itemCost);
export const isCustomItem = (item) => {
    const { itemType } = item;
    const { LABOR, OTHER } = QuoteItemTypes;

    return itemType === LABOR || itemType === OTHER;
};
export const shouldShowFormattedCost = (totalCostOrder, items) => {
    const hasOnlyCustomItems = items.every((item) => isCustomItem(item));
    const showCost = Boolean(totalCostOrder) || items.length === 0 || hasOnlyCustomItems;

    return showCost;
};
export const getTotalCostForQuote = (isHideCost, worksheetForm, quoteItems) => {
    const { formattedTotalPrice, totalCostOrder, formattedTotalCostOrder } = worksheetForm;

    if (isHideCost) {
        return formattedTotalPrice;
    }
    if (shouldShowFormattedCost(totalCostOrder, quoteItems)) {
        return formattedTotalCostOrder;
    }

    return fcoM('rs.getparts.quoteCall', 'Call for Pricing');
};
export const isLaborItem = (item) => item.itemType === QuoteItemTypes.LABOR;
export const isOtherItem = (item) => item.itemType === QuoteItemTypes.OTHER;
export const hasLaborItem = (quoteItems = []) => quoteItems.some((item) => isLaborItem(item));
export const hasOtherItem = (quoteItems = []) => quoteItems.some((item) => isOtherItem(item));
